"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("../../Typography"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _AppBarMobile = require("./AppBarMobile.types");
var Styled = _interopRequireWildcard(require("./AppBarMobile.styles"));
var _messages = _interopRequireDefault(require("./messages"));
var _IconButton2 = require("../../IconButton/IconButton.types");
var _Typography2 = require("../../Typography/Typography.types");
var _AppBarMobile3 = require("./AppBarMobile.utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var headingTags = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6'
};
var setHeadingTagToTitle = function setHeadingTagToTitle() {
  var heading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'h1';
  return headingTags[heading];
};
var runPropsValidations = function runPropsValidations(_ref) {
  var title = _ref.title,
    logo = _ref.logo,
    searchBar = _ref.searchBar,
    subtitle = _ref.subtitle,
    tabs = _ref.tabs,
    children = _ref.children,
    chipAssistGroup = _ref.chipAssistGroup;
  if (title && (logo || searchBar)) {
    throw new Error("Invalid props. You can't use title with logo or searchBar");
  }
  if (logo && searchBar) {
    throw new Error("Invalid props. You can't use logo with searchBar");
  }
  if (subtitle && (tabs || children || chipAssistGroup)) {
    throw new Error("Invalid props. You can't use subtitle with tabs, children or chipAssistGroup");
  }
  if (tabs && children) {
    throw new Error("Invalid props. You can't use tabs with children");
  }
  if (chipAssistGroup && children) {
    throw new Error("Invalid props. You can't use chipAssistGroup with children");
  }
  if (chipAssistGroup && tabs) {
    throw new Error("Invalid props. You can't use chipAssistGroup with tabs");
  }
};
var handleScrollEvents = function handleScrollEvents(setPosition) {
  var currentPosition = document.body.getBoundingClientRect().top;
  setPosition(Math.abs(currentPosition));
};
var renderCenterContent = function renderCenterContent(_ref2) {
  var title = _ref2.title,
    searchBar = _ref2.searchBar,
    logo = _ref2.logo,
    scrollPosition = _ref2.scrollPosition;
  return /*#__PURE__*/_react["default"].createElement(Styled.NavMainContent, {
    scrollPosition: scrollPosition
  }, title ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: _Typography2.Level.BODY_STRONG,
    noWrap: true,
    as: "span"
  }, title) : searchBar || logo);
};
var renderPageActions = function renderPageActions(_ref3) {
  var pageActions = _ref3.pageActions,
    scrollPosition = _ref3.scrollPosition,
    variant = _ref3.variant;
  if (pageActions) return /*#__PURE__*/_react["default"].createElement(Styled.PageActions, {
    scrollPosition: scrollPosition,
    variant: variant
  }, pageActions);
  return null;
};
var renderComplementaryContent = function renderComplementaryContent(_ref4) {
  var subtitle = _ref4.subtitle,
    tabs = _ref4.tabs,
    propertyCard = _ref4.propertyCard,
    scrollPosition = _ref4.scrollPosition,
    children = _ref4.children,
    chipAssistGroup = _ref4.chipAssistGroup;
  if (subtitle) return /*#__PURE__*/_react["default"].createElement(Styled.ComplementaryContent, {
    scrollPosition: scrollPosition,
    role: "heading",
    "aria-level": "2"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: _Typography2.Level.BODY,
    kind: _Typography2.Kind.LIGHTER,
    className: "appBarMobile__subtitle"
  }, subtitle));
  if (tabs || propertyCard || children || chipAssistGroup) {
    return /*#__PURE__*/_react["default"].createElement(Styled.ComplementaryContent, {
      scrollPosition: scrollPosition,
      noPadding: tabs || chipAssistGroup
    }, tabs || propertyCard || children || chipAssistGroup);
  }
  return null;
};
var AppBarMobile = function AppBarMobile(_ref5) {
  var variant = _ref5.variant,
    navigationIcon = _ref5.navigationIcon,
    title = _ref5.title,
    titleAsTag = _ref5.titleAsTag,
    subtitle = _ref5.subtitle,
    logo = _ref5.logo,
    searchBar = _ref5.searchBar,
    tabs = _ref5.tabs,
    children = _ref5.children,
    propertyCard = _ref5.propertyCard,
    pageActions = _ref5.pageActions,
    isFloating = _ref5.isFloating,
    chipAssistGroup = _ref5.chipAssistGroup;
  var intl = (0, _reactIntl.useIntl)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    documentHeight = _useState4[0],
    setDocumentHeight = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    deviceHeight = _useState6[0],
    setDeviceHeight = _useState6[1];
  (0, _react.useEffect)(function () {
    runPropsValidations({
      title: title,
      logo: logo,
      searchBar: searchBar,
      subtitle: subtitle,
      tabs: tabs,
      children: children,
      chipAssistGroup: chipAssistGroup
    });
  }, []);
  (0, _react.useEffect)(function () {
    setDocumentHeight(document.body.scrollHeight);
    var debouncedSetDocumentHeight = (0, _AppBarMobile3.debounce)(setDocumentHeight, 500);
    var mutationObserver = new MutationObserver(function () {
      return debouncedSetDocumentHeight(document.body.scrollHeight);
    });
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    return function () {
      return mutationObserver.disconnect();
    };
  }, []);
  (0, _react.useEffect)(function () {
    setDeviceHeight(window.innerHeight);
    var debouncedSetDeviceHeight = (0, _AppBarMobile3.debounce)(setDeviceHeight, 200);
    var handleDeviceHeightChange = function handleDeviceHeightChange() {
      return debouncedSetDeviceHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleDeviceHeightChange);
    return function () {
      return window.removeEventListener('resize', handleDeviceHeightChange);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var handleScrollUpdates = function handleScrollUpdates() {
      return handleScrollEvents(setScrollPosition);
    };
    var MIN_SPACE_REQUIRED_TO_ANIMATE = 100;
    var shouldAnimateAppBarScroll = documentHeight - deviceHeight >= MIN_SPACE_REQUIRED_TO_ANIMATE;
    if (shouldAnimateAppBarScroll) {
      window.addEventListener('scroll', handleScrollUpdates);
      return function cleanup() {
        window.removeEventListener('scroll', handleScrollUpdates);
      };
    }
    return function () {
      return {};
    };
  }, [documentHeight, deviceHeight]);
  var iconVariantMap = new Map([[_AppBarMobile.Variant.TRANSPARENT, _IconButton2.Variant.HIGHLIGHT], [_AppBarMobile.Variant.TRANSPARENT_INVERSE, _IconButton2.Variant.INVERSE], [_AppBarMobile.Variant.DEFAULT, _IconButton2.Variant.DEFAULT]]);
  return /*#__PURE__*/_react["default"].createElement(Styled.AppBarMobileWrapper, {
    scrollPosition: scrollPosition,
    variant: variant,
    isFloating: isFloating,
    role: "navigation",
    "aria-label": intl.formatMessage(_messages["default"].ariaLabelNavigation)
  }, /*#__PURE__*/_react["default"].createElement(Styled.Nav, {
    scrollPosition: scrollPosition,
    variant: variant,
    "aria-labelledby": "AppBarMain"
  }, navigationIcon && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "Cozy__AppBarMobile-NavigationButton",
    "data-testid": navigationIcon['data-testid'],
    onClick: navigationIcon.onClick,
    icon: navigationIcon.icon,
    "aria-label": navigationIcon['aria-label'],
    variant: iconVariantMap.get(variant),
    size: navigationIcon.size
  }), renderCenterContent({
    title: title,
    searchBar: searchBar,
    logo: logo,
    scrollPosition: scrollPosition
  }), renderPageActions({
    pageActions: pageActions,
    scrollPosition: scrollPosition,
    variant: variant
  })), title && variant === _AppBarMobile.Variant.DEFAULT && /*#__PURE__*/_react["default"].createElement(Styled.TitleWrapper, {
    $scrollPosition: scrollPosition
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: _Typography2.Level.HEADING,
    className: "appBarMobile__title--main",
    as: setHeadingTagToTitle(titleAsTag),
    id: "AppBarMain"
  }, title)), renderComplementaryContent({
    subtitle: subtitle,
    tabs: tabs,
    propertyCard: propertyCard,
    scrollPosition: scrollPosition,
    children: children,
    chipAssistGroup: chipAssistGroup
  }));
};
AppBarMobile.propTypes = process.env.NODE_ENV !== "production" ? {
  variant: _propTypes["default"].oneOf(Object.values(_AppBarMobile.Variant)),
  navigationIcon: _propTypes["default"].shape({
    icon: _propTypes["default"].elementType,
    onClick: _propTypes["default"].func,
    'aria-label': _propTypes["default"].string,
    'data-testid': _propTypes["default"].string,
    size: _propTypes["default"].string
  }),
  title: _propTypes["default"].string,
  titleAsTag: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  logo: _propTypes["default"].elementType,
  searchBar: _propTypes["default"].elementType,
  tabs: _propTypes["default"].elementType,
  propertyCard: _propTypes["default"].elementType,
  children: _propTypes["default"].elementType,
  pageActions: _propTypes["default"].element,
  isFloating: _propTypes["default"].bool,
  chipAssistGroup: _propTypes["default"].elementType
} : {};
AppBarMobile.defaultProps = {
  variant: _AppBarMobile.Variant.DEFAULT,
  navigationIcon: null,
  title: '',
  titleAsTag: 'h1',
  subtitle: '',
  logo: null,
  searchBar: null,
  tabs: null,
  propertyCard: null,
  children: null,
  pageActions: null,
  isFloating: false,
  chipAssistGroup: null
};
var _default = exports["default"] = AppBarMobile;